import React from 'react'
import { sharePermissionConstants } from '../../constants/sharePermissionConstants'
import { apiErrorMessages } from './apiErrorMessages'

export function renderCloseIcon(onClose) {
  return (
    <div className="ppvx_modal-header__close">
      <button
        className="ppvx_modal-header__close-btn"
        data-action-close-modal="true"
        id="hide-my-overpanel"
        aria-label="close lightbox"
        onClick={() => onClose(false)}
      />
    </div>
  )
}

export function renderPermissionBoxHeader(title, onClose) {
  return (
    <header className="ppvx_modal-header ppvx_modal-header--no-logo">
      <div className="ppvx_modal-header__action dFlexCenter share__permission_header">
        {title}
      </div>
      {renderCloseIcon(onClose)}
    </header>
  )
}

export function renderStatusMsg(statusMsg) {
  return (
    <div
      className={`ppvx_alert ppvx_alert--type_${statusMsg.status} permission__request_alert-box`}
      data-test-id={`permission__request_alert_${statusMsg.status}`}
      role="alert"
    >
      {' '}
      {statusMsg.msg}
    </div>
  )
}

export function getPermissionRequestTableHeaders(headerList, selectedTabKey) {
  return Object.fromEntries(
    Object.entries(headerList).filter(([_key, value]) =>
      value.renderFor.includes(selectedTabKey),
    ),
  )
}

export function renderRequestStatus(status) {
  return (
    <div
      className={`share__permission-request_details_value share__permission-status status__${status.toLowerCase()}`}
    >
      {sharePermissionConstants.permissionStatusLabel[status]}
    </div>
  )
}

// Helper: check array equality ignoring order
export function arraysEqualIgnoreOrder(a = [], b = []) {
  if (a.length !== b.length) return false
  const sortedA = [...a].sort()
  const sortedB = [...b].sort()
  return sortedA.every((val, i) => val === sortedB[i])
}

export function renderFieldLabel(title, note = '', isMandatory = false) {
  return (
    <div className="share__permission-content_label">
      {title}
      {note !== '' && (
        <>
          <div className="ppvx_icon ppvx_icon--size_xl2 ppvx_icon-info-alt share__permission_info-label tooltip">
            <span
              className="info_icon_tooltiptext ppvx_text--md"
              dangerouslySetInnerHTML={{ __html: note }}
            />
          </div>
          {` :`}
        </>
      )}
      {isMandatory && <span className="mandatory">*</span>}
    </div>
  )
}

export function validateTextareaContent(content, field) {
  const linkRegex = /\b(?:(?:https?|ftp|http):\/\/|www\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/g
  const htmlRegex = /<\/?[^>]+(>|$)/g

  const isLinkPresent = linkRegex.test(content)
  const isTagsPresent = htmlRegex.test(content)

  if (
    content.length < sharePermissionConstants.fields[field].minCharacters ||
    content.length > sharePermissionConstants.fields[field].maxCharacters
  ) {
    return apiErrorMessages.INVALID_STRING_LENGTH[field]
  }

  if (isLinkPresent && field === 'comment') {
    return sharePermissionConstants.fields[field].linkNotAllowedAlert
  }
  if (isTagsPresent) {
    return sharePermissionConstants.fields[field].htmlTagsNotAllowed
  }
  return ''
}

export function renderSpinner() {
  return (
    <div className="spinnerInProgress" style={{ top: '0px' }}>
      <p className="ppvx_loading-spinner" role="alert">
        <span className="ppvx_loading-spinner__screenreader" />
      </p>
    </div>
  )
}

export function truncateLongText(longText, length) {
  if (longText.length > length) return longText.substr(0, length) + '...'
  return longText
}

export function renderLinkedText(text) {
  const URL_REGEX = /((https?:\/\/)[^\s<>"']+[^\s<>"'.,!?;:)\]])/gi // trims common trailing punctuation

  const parts = []
  let lastIndex = 0

  text.replace(URL_REGEX, (match, _full, _proto, offset) => {
    // Push text before the link
    if (offset > lastIndex) parts.push(text.slice(lastIndex, offset))

    // Normalize & validate URL
    let href = match
    // Extra guard: try constructing a URL object (filters weird schemes)
    try {
      const u = new URL(href)
      if (u.protocol !== 'http:' && u.protocol !== 'https:') throw new Error()
      href = u.toString()
    } catch {
      // Not a valid URL — keep as plain text
      parts.push(match)
      lastIndex = offset + match.length
      return match
    }

    parts.push(
      <a
        key={`${offset}-${href}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline' }}
      >
        {href}
      </a>,
    )

    lastIndex = offset + match.length
    return match
  })

  // Tail text after the last link
  if (lastIndex < text.length) parts.push(text.slice(lastIndex))
  return parts
}

export function LinkifiedText({ text }) {
  return <span>{renderLinkedText(text)}</span>
}

export default {
  renderPermissionBoxHeader,
  renderStatusMsg,
  getPermissionRequestTableHeaders,
  renderRequestStatus,
  arraysEqualIgnoreOrder,
  renderFieldLabel,
  renderSpinner,
  truncateLongText,
  LinkifiedText,
}
